import { URLS } from '../App/constants';

export const DESKTOP_COMPANY_ITEMS = [
  {
    name: 'Users',
    to: URLS.users,
    icon: 'user',
  },
  {
    name: 'Companies',
    to: URLS.companies,
    icon: 'toolbox',
  },
  {
    name: 'Rate Requests',
    to: URLS.rateRequests,
    icon: 'pound',
  },
  {
    name: 'Jobs',
    to: URLS.jobs,
    icon: 'job',
  },
  {
    name: 'Loans',
    to: URLS.loans,
    icon: 'payment',
  },
  {
    name: 'Payments',
    to: URLS.payments,
    icon: 'deposit',
  },
  {
    name: 'Partners',
    to: URLS.partners,
    icon: 'person',
  },
];

export interface DesktopMenuItem {
  name: string;
  to: string;
  active?: boolean;
}

export const DESKTOP_MENU_ITEMS: DesktopMenuItem[] = [
  {
    name: 'Users',
    to: URLS.users,
  },
  {
    name: 'Companies',
    to: URLS.companies,
  },
  {
    name: 'Rate Requests',
    to: URLS.rateRequests,
  },
  {
    name: 'Jobs',
    to: URLS.jobs,
  },
  {
    name: 'Loans',
    to: URLS.loans,
  },
  {
    name: 'Payments',
    to: URLS.payments,
  },
  {
    name: 'Partners',
    to: URLS.partners,
  },
];
